export const UserAgent = {
  CALENDAR_EDITOR: "Easy Flow Calendar",
  GREETING_CARD_EDITOR: "Greeting Cards Editor",
  MUG_EDITOR: "Mug Editor",
  CANVAS_EDITOR: "Canvas Editor",
  PHOTOBOOK_EDITOR_VALUE: "HTML5 Photobook Editor",
  NEXT_EDITOR_WEB_VALUE: "NeXt Editor Web",
  RESNAP: "ReSnap"
};

export const PageParamName = "page";
